const hasUndefined = (obj: any, arr: string[]): boolean => {
  if (!obj) return true;
  const undefinedField = arr.find((key) => !obj[key]);
  return !!undefinedField;
};

export default hasUndefined;
